import { gql } from '@apollo/client';
import { Accordion } from '@apollo/orbit';
import React, { useMemo } from 'react';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

import {
  BuildConfig,
  BuildConfigBuildCheckResultFragment,
} from './BuildConfig';
import {
  CheckDetailsConfigurationSchemaDiffValidationConfigFragment,
  OperationConfig,
} from './OperationConfig';

export const CheckDetailsConfigurationWorkflowFragment = gql`
  fragment CheckDetailsConfigurationWorkflowFragment on CheckWorkflow {
    id
    createdAt
    baseVariant {
      id
      name
    }
    validationConfig {
      ...CheckDetailsConfigurationSchemaDiffValidationConfigFragment
    }
    tasks {
      id
      ... on BuildCheckTask {
        id
        buildResult {
          id
          ...BuildConfigBuildCheckResultFragment
        }
      }
    }
  }
  ${BuildConfigBuildCheckResultFragment}
  ${CheckDetailsConfigurationSchemaDiffValidationConfigFragment}
`;

export function CheckDetailsConfiguration({
  graphTitle,
  graphId,
  workflow,
}: {
  graphTitle: string;
  graphId: string;
  workflow: GraphQLTypes.CheckDetailsConfigurationWorkflowFragment;
}) {
  const buildResult = useMemo(
    () =>
      workflow.tasks.find(
        (
          t,
        ): t is Extract<
          typeof t,
          { __typename: 'CompositionCheckTask' | 'FilterCheckTask' }
        > =>
          t.__typename === 'CompositionCheckTask' ||
          t.__typename === 'FilterCheckTask',
      )?.buildResult,
    [workflow],
  );

  return (
    <Accordion allowMultiple={true}>
      {buildResult && <BuildConfig buildResult={buildResult} />}
      {workflow.validationConfig && (
        <OperationConfig
          graphTitle={graphTitle}
          config={workflow.validationConfig}
          createdAt={workflow.createdAt}
          graphId={graphId}
          baseVariant={workflow.baseVariant?.name}
        />
      )}
    </Accordion>
  );
}
